import './aggregatorAcceptConsentStepOK.scss';

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

// @components
import { OKButton } from 'commonsComponents/OKButton';
import { OKSectionBox } from 'commonsComponents/OKSectionBox';
import OKModal from 'commonsComponents/OKModal';

// @utilities
const { formatText } = require('core/i18n').i18n;
import { withRouter } from 'react-router-dom';

// @constants
import Storage from 'utilities/storage';
import { SELECTED_BANK, PSD2_FLOW_TYPE } from 'constants/aggregator/localStorageKeys';
import { RENEW_CONSENT, CREATE_CONSENT } from 'constants/aggregator/psd2DecoupledFlowType';
import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';

const {
  recordPath,
  recordLink,
  PROC_AGGREGATOR,
  PROC_AGGREGATOR_CONSENT,
  PROC_AGGREGATOR_CONSENT_SUCCESS,
  PROC_AGGREGATOR_CONSENT_SUCCESS_ENTER_CREDENTIALS,
  PROC_AGGREGATOR_RENEW_CONSENT,
  PROC_AGGREGATOR_RENEW_CONSENT_SUCCESS,
  PROC_END,
} = require('utilities/tagging');

// @ actions
import { getConsentInfo, initStoreConsentsPSD2 } from 'actions/aggregator/aggregatorConsentsPSD2';
import { getEntitiesData, getGlobalPositionTink } from 'actions/aggregator/aggregatorData';

class AggregatorAcceptConsentStepOK extends React.Component {
  constructor(props) {
    super(props);
    const { bankCode, bankName, bankLogo, scrapingCredentials, consentId, userBankId } =
      Storage.localStorage.get(SELECTED_BANK) || {};
    const psd2FlowType = Storage.localStorage.get(PSD2_FLOW_TYPE) || '';

    this.state = {
      modal: false,
      name: bankName,
      logo: bankLogo,
      bankCode,
      scrapingCredentials,
      consentId,
      userBankId,
      psd2FlowType,
      productList: null,
    };
  }

  componentWillMount() {
    const { psd2FlowType } = this.state;
    const { isTinkAggregator, getEntitiesData, getGlobalPositionTink } = this.props;

    if (psd2FlowType === CREATE_CONSENT) {
      recordPath(PROC_AGGREGATOR_CONSENT_SUCCESS, null, PROC_AGGREGATOR_CONSENT, PROC_END);
    } else if (psd2FlowType === RENEW_CONSENT) {
      recordPath(
        PROC_AGGREGATOR_RENEW_CONSENT_SUCCESS,
        null,
        PROC_AGGREGATOR_RENEW_CONSENT,
        PROC_END
      );
    }

    isTinkAggregator ? getGlobalPositionTink() : getEntitiesData();
  }

  componentWillUnmount() {
    initStoreConsentsPSD2();
  }

  formatData = () => {
    const formatedData = [
      [formatText('aggregatorPSD2-consentOkFinancialEntity'), [this.state && this.state.name]],
      [
        formatText('aggregatorPSD2-consentOkConsentType'),
        [formatText('aggregatorPSD2-consentOkRecurring')],
      ],
      [formatText('aggregatorPSD2-consentOkConsentDate'), [moment().format('D MMM YYYY')]],
    ];

    return formatedData;
  };

  buildList = () =>
    this.formatData().map((item, index) => {
      const title = item[0];
      let data = item[1].map((data, i) => (
        <p className="data" key={i}>
          {data}
        </p>
      ));

      return (
        <li key={index} className="aggregator-accept-consent-ok__data-list-item">
          <p>{title}</p>
          {data}
        </li>
      );
    });

  handleGoToLink = link => {
    recordLink(PROC_AGGREGATOR, PROC_AGGREGATOR_CONSENT_SUCCESS_ENTER_CREDENTIALS);
    this.props.history.push(link);
  };

  handlePrimaryButtonClick = () => {
    const { userBankId, consentId } = this.state;
    this.props.initStoreConsentsPSD2();
    this.props.getConsentInfo(userBankId, consentId);
  };

  handleModalCloseButtonClick = () => {
    this.props.initStoreConsentsPSD2();
    this.props.history.push(`/myprofile/global`);
  };

  render() {
    const { name, logo, userBankId, psd2FlowType } = this.state;

    const list = this.buildList();
    const scrapingCredentials = this.props.dataGP.getIn([
      'banks',
      userBankId,
      'scrapingCredentials',
    ]);
    const credentialsButton = scrapingCredentials ? (
      <div />
    ) : (
      <OKButton
        modifier="secondary"
        onClick={() =>
          this.handleGoToLink(`/myprofile/global/entities/add/credentials/scrapping/${userBankId}`)
        }
        targetBlank={false}
      >
        {formatText('aggregatorPSD2-consentOkCredentialsButton')}
      </OKButton>
    );

    const isCreateFlow = psd2FlowType === CREATE_CONSENT;
    const titleText = isCreateFlow
      ? 'aggregatorPSD2-consentOkTitle'
      : 'aggregatorPSD2-renewConsentOkTitle';
    const mainText = isCreateFlow
      ? 'aggregatorPSD2-consentOkMainText'
      : 'aggregatorPSD2-renewConsentOkMainText';
    const secondaryText = isCreateFlow
      ? 'aggregatorPSD2-consentOkSecondaryText'
      : 'aggregatorPSD2-renewConsentOkSecondaryText';

    return (
      <OKSectionBox
        className="col-md-8 aggregator-accept-consent-ok"
        title={formatText(titleText)}
        icon="success"
        titleSeparator
      >
        <div className="aggregator-accept-consent-ok__content">
          <p>{formatText(mainText)}</p>
          <p>{formatText(secondaryText, [name])}</p>
          <img className="aggregator-accept-consent-ok__logo" src={logo} />
          <p className="aggregator-accept-consent-ok__data-title">
            {formatText('aggregatorPSD2-consentOkDataTitle')}
          </p>
          <ul className="aggregator-accept-consent-ok__data-list">{list}</ul>
          <div className="aggregator-accept-consent-ok__buttons">
            {credentialsButton}
            <OKButton
              modifier="link-complementary"
              onClick={() => this.handleGoToLink('/myprofile/global')}
            >
              {formatText('aggregatorPSD2-consentOkGPButton')}
            </OKButton>
          </div>
        </div>
        <OKModal
          isOpen={this.props.errorConsentInfo}
          title={formatText('aggregatorPSD2-redirectionUrlErrorTitle')}
          content={formatText('aggregatorPSD2-redirectionUrlErrorMessage')}
          footerType="action"
          primaryButtonText={formatText('aggregatorPSD2-redirectionUrlErrorButton')}
          onPrimaryButtonClick={this.handlePrimaryButtonClick}
          onCloseCallback={() => this.handleModalCloseButtonClick()}
        />
      </OKSectionBox>
    );
  }
}

AggregatorAcceptConsentStepOK.propTypes = {
  getConsentInfo: PropTypes.func.isRequired,
  initStoreConsentsPSD2: PropTypes.func.isRequired,
  scrapingCredentials: PropTypes.bool,
  dataGP: PropTypes.object,
  consentInfo: PropTypes.object,
  history: PropTypes.object.isRequired,
  errorConsentInfo: PropTypes.object,
  getEntitiesData: PropTypes.func.isRequired,
  getGlobalPositionTink: PropTypes.func.isRequired,
  isTinkAggregator: PropTypes.bool.isRequired,
};

export default connect(
  state => ({
    consentInfo: state.aggregatorConsentsPSD2.get('consentInfo'),
    errorConsentInfo: state.aggregatorConsentsPSD2.get('errorConsentInfo'),
    dataGP: state.aggregatorData.get('data'),
    isTinkAggregator: state.flagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR),
  }),
  {
    getConsentInfo,
    initStoreConsentsPSD2,
    getEntitiesData,
    getGlobalPositionTink,
  }
)(withRouter(AggregatorAcceptConsentStepOK));
